<template>
  <div class="search-box me-2 mb-2 d-inline">
    <div class="position-relative">
      <b-form-input
          type="text"
          v-model="search"
          class="bg-light border-light rounded"
          :placeholder="placeHolder ? placeHolder : $t('common.search')"
          debounce="800"
          :disabled="disabled"
      >
      </b-form-input>
      <i class="bx bx-search-alt search-icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataTableSearch",
  props: {
    placeHolder: {
      type: String,
      Default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: ''
    }
  },
  watch: {
    search(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>

</style>